export default "__VITE_ASSET__CESo$sFU__"